import { Platform } from 'react-native';
import DownloadUtils from '../DownloadUtils';
export const getMappedURI = (uri) => {
    if (!uri ||
        /^https?:\/\//.test(uri) ||
        /^file:\/\//.test(uri)) {
        return uri;
    }
    const prefix = Platform.OS === 'android' ? 'file://' : '';
    if (/^\//.test(uri)) {
        return `${prefix}${uri}`;
    }
    if (!uri.includes(DownloadUtils.directories.documents)) {
        return `${prefix}${DownloadUtils.directories.documents}/${uri}`;
    }
    else {
        return uri;
    }
};
//# sourceMappingURL=getMappedURI.js.map